module.exports = __webpack_public_path__ + "static/img/brees-2012-slide-4.7980aed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-slide-4.jpg
// module id = Dl5b
// module chunks = 1